import script from "./edit-delta.vue?vue&type=script&lang=jsx"
export * from "./edit-delta.vue?vue&type=script&lang=jsx"

import "./edit-delta.vue?vue&type=style&index=0&id=44f466ca&lang=scss"

const __exports__ = script;

export default __exports__